import React from 'react';
import { Link } from 'react-router';

import './index.css';

export type RacesIndexSection = {
	id: string;
	label: string;
	to: string;
	description: React.ReactNode;
};

const RACES_INDEX_SECTIONS: RacesIndexSection[] = [
	{
		id: 'blindKaizo',
		label: 'Blind Kaizo',
		to: '/races?raceType=blindKaizo',
		description: (
			<>
				<p>
					Every Saturday at 8 PM Eastern time, Romhack Races hosts a race of a never before seen Super Mario World kaizo level. Members of the community sign up to create a level and Romhack Races volunteers test and provide feedback on the level. After it becomes Race Ready, it is rated and ready to go for race time. Anyone and everyone is then welcome to sign up as a racer and five minutes before race start, the level patch is provided. Racers stream to their Twitch channels and they are restreamed to the Romhack Races Twitch channel where the viewers can see the current leaders and listen to commentary from experienced kaizo players.
				</p>
				<p>
					Occasionally, the Blind Kaizo race will do a double header or race other games, such as Super Mario Bros. 2 or 3. These levels are also designed with kaizo in mind, making them challenging levels to race.
				</p>
			</>
		),
	},
	{
		id: 'mysteryMonday',
		label: 'Mystery Monday',
		to: '/races?raceType=mysteryMonday',
		description: (
			<p>
				In 2019 and 2020, Romhack Races ran an event called Mystery Monday. This event invited racers to play a standard-difficulty Super Mario World romhack that existed prior to the race. Racers were allowed to join even if they had played before, and this combined with the hacks not being kaizo-difficulty meant the races often consisted of the entire romhack.
			</p>
		),
	},
];

export default function Index() {
	return (
		<div>
			<div className="panel">
				<p>
					Romhack Races has hosted multiple weekly races throughout its lifetime. It started in 2018 with the Blind Kaizo races and expanded to Mystery Mondays in 2019.
				</p>
			</div>

			{RACES_INDEX_SECTIONS.map(({ id, label, to, description }) => (
				<div key={id} className="panel">
					<h2>{label}</h2>
					<div className="racesIndexSectionDescription">{description}</div>
					<Link to={to} className="racesIndexCtaLink">View {label} →</Link>
				</div>
			))}
		</div>
	);
}
